import { render, staticRenderFns } from "./fieldNumero.vue?vue&type=template&id=4fadf804"
import script from "./fieldNumero.vue?vue&type=script&lang=js"
export * from "./fieldNumero.vue?vue&type=script&lang=js"
import style0 from "./fieldNumero.vue?vue&type=style&index=0&id=4fadf804&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports